import React, { useState } from 'react';
import BaseModal from '../theme/modals/BaseModal';
import { useDoorCrewCard } from './DoorCrewCardContext';

interface SeatActionsProps {
  seatId: number;
  onDeleteSeat: () => void;
  showUnassign?: boolean;
}

export default function SeatActions({
  seatId,
  onDeleteSeat,
  showUnassign = true,
}: SeatActionsProps) {
  const { onUnassignSeat, crew } = useDoorCrewCard();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const isLastSeat = crew.seats.length <= 1;

  const confirmDeleteSeat = () => {
    setShowDeleteConfirm(false);
    onDeleteSeat();
  };

  return (
    <div className="line-item seat-actions" data-component="SeatActions">
      {showUnassign && (
        <button
          type="button"
          className="seat-action-link"
          onClick={() => onUnassignSeat(seatId)}
          title="Unassign canvasser"
          data-component="SeatActions"
          data-attr="seat-unassign"
        >
          <i className="fas fa-user-slash" />
          Unassign
        </button>
      )}
      <button
        type="button"
        className="seat-action-link"
        onClick={() => setShowDeleteConfirm(true)}
        title="Delete seat"
        data-component="SeatActions"
        data-attr="seat-delete"
      >
        <i className="fas fa-trash" />
        Delete
      </button>

      <BaseModal open={showDeleteConfirm} onClose={() => setShowDeleteConfirm(false)} center>
        <div
          className="modal-internal-wrapper"
          data-component="SeatActions"
          data-attr="seat-delete-confirm-modal"
        >
          <p>
            {isLastSeat ? (
              <>
                This is the last seat. Deleting it will also delete <b>Crew {crew.id}</b>. Continue?
              </>
            ) : (
              'Are you sure you want to delete this seat?'
            )}
          </p>
          <div className="button-wrapper">
            <div
              className="button"
              onClick={confirmDeleteSeat}
              data-component="SeatActions"
              data-attr="seat-delete-confirm"
            >
              Delete
            </div>
            <div
              className="button button-outline"
              onClick={() => setShowDeleteConfirm(false)}
              data-component="SeatActions"
              data-attr="seat-delete-cancel"
            >
              Cancel
            </div>
          </div>
        </div>
      </BaseModal>
    </div>
  );
}
